import { UPDATE_CURRENT_PATH } from "../Action/pageRoot";

const initialState = {
  page: { area: "", subArea: "", subArea2: "", subArea3: "" },
};

function accountReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_CURRENT_PATH:
      return {
        ...state,
        page: {
          area: action.area,
          subArea: action.subArea,
          subArea2: action.subArea2,
          subArea3: action.subArea3,
        },
      };
    default:
      return state;
  }
}

export default accountReducer;
